<template>
  <table class="table table-bordered table-hover">
    <thead class="bg-light">
      <tr>
        <th>Gender</th>
        <th>Sexual Orientation</th>
        <th>City</th>
        <th>State</th>
        <th>Age</th>
        <th>Race/Ethnicity</th>
        <th>Military Service</th>
        <th>Type of Sexual Violence Experienced</th>
        <th>Age During Abuse</th>
        <th>Perpetrator(s)</th>
        <th>Rape Kit Received</th>
        <th>Reported to Police</th>
        <th>Application Submission Date</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="application in applications" :key="application.key">
        <td>{{ application.section1.gender }}</td>
        <td>{{ application.section1.sexualOrientation }}</td>
        <td>{{ application.section1.city }}</td>
        <td>{{ application.section1.state }}</td>
        <td>{{ application.age }}</td>
        <td>{{ application.races.join(", ") }}</td>
        <td>
          {{ application.section1.militaryRadio1 === true ? "Yes" : "No" }}
        </td>
        <td>{{ application.experienceTypes.join(", ") }}</td>
        <td>{{ application.experienceAges.join(", ") }}</td>
        <td>{{ application.perpetrators.join(", ") }}</td>
        <td>{{ application.rapeKitsReceived.join(", ") }}</td>
        <td>{{ application.reportedToPolice.join(", ") }}</td>
        <td>{{ application.submissionDate }}</td>
        <td>
          <button
            class="btn btn-link"
            @click="() => editApplication(application)"
          >
            Edit
          </button>
          <button
            class="btn btn-link text-danger"
            @click="() => deleteApplication(application)"
          >
            Delete
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    applications: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    editApplication: {
      type: Function,
      required: true,
      default: () => {}
    },
    deleteApplication: {
      type: Function,
      required: true,
      default: () => {}
    }
  }
};
</script>

<style></style>
